.wrapper {
  display: block;
  width: 40em;
  min-width: 40em;
  position: relative;
  pointer-events: none;
  user-select: none;
  line-height: 1.6;
  font-size: 1em;
  color: var(--color-black);
}
.container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: var(--color-white);
  width: 100%;
  border-radius: 4em;

  @media (prefers-color-scheme: light) {
    border: 0.3em solid var(--section-color-dim);
  }
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2em;
  margin-top: 1em;
  margin-bottom: 4em;
}
.link {
  font-size: 1.2em;
  font-weight: 400;
}

.logo {
  text-align: center;
  font-size: 3em;
  font-weight: 500;
}
.cart {
  padding: 0.4em 2em;
  border: 0.15em solid transparent;
  border-radius: 4em;
  background-origin: border-box;
  background-clip: padding-box, border-box;
  background-image:
    linear-gradient(var(--color-white), var(--color-white)),
    linear-gradient(to left, var(--section-color), var(--section-color-alt));
}
.product {
  display: flex;
  justify-content: space-between;
  padding: 0 2em;
  margin-bottom: 1em;
  height: 15em;
}
.image {
  flex: 1;
  object-fit: contain;
  height: 100%;
}
.description {
  flex: 1;
}
.descriptionTitle {
  font-size: 1.4em;
  font-weight: 700;
  display: block;
}
.descriptionButton {
  border-radius: 2em;
  background: linear-gradient(
    to right,
    var(--section-color-dark),
    var(--section-color-light)
  );
  color: var(--color-white);
  padding: 0.6em 2em;
  display: inline-flex;
  margin: 1em 0;
  margin-bottom: 1.5em;

  font-weight: 500;
}
.descriptionText {
  display: block;
}

.review {
  padding: 2em;
}
.rating {
  color: #fec703;
  margin-bottom: 0.5em;
}
.footer {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 2em;
  background: #f4f2f4;
  border-bottom-left-radius: 4em;
  border-bottom-right-radius: 4em;
}

.loading {
  opacity: 0;
}
.lowRes {
  filter: blur(1em) grayscale(0.6);
  opacity: 0.3;
}
.hydratePartial .hydrated,
.hydrateAll div {
  animation-name: pulse-red;
  animation-iteration-count: infinite;
  animation-duration: 2s;
  border-radius: 2em;
}

.delay {
  animation-delay: calc(var(--delay) * 100ms);
}

@media (prefers-reduced-motion) {
  .hydratePartial .hydrated,
  .hydrateAll div {
    animation: none;
    box-shadow: 0 0 0 0.5em var(--color-red-light);
  }
}

@keyframes pulse-red {
  0% {
    box-shadow: 0 0 0 0 var(--color-red-light);
  }

  100% {
    box-shadow: 0 0 0 1rem transparent;
  }
}

.title {
  position: relative;
  z-index: 1;
  left: 50%;
  translate: -50% 0;
  margin-top: -1.2em;
  height: 2em;
  width: 8em;
  padding: 1em;
  border-radius: 2em;
  background: var(--color-white);
  box-shadow: 0 0 1em -5px var(--section-color-dim);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 300;
  font-size: 2em;
  border: 1px solid var(--color-gray-light);
}

.title > img {
  height: 0.6lh;
  margin-right: 0.8ch;
}

.titleMarko {
  composes: title;
  width: 10em;
  font-weight: 500;
  border: 2px solid transparent;
  background-origin: border-box;
  background-clip: padding-box, border-box;
  background-image:
    linear-gradient(var(--color-white), var(--color-white)),
    linear-gradient(to right, var(--section-color), var(--section-color-alt));
}
